import React from 'react';
import "../css/bootstrap.css"
import "../css/app.css"

export const Contact = () => {
    return(
        <div className="container black projects">
            <hr></hr>
            <h1 className="projecttitle">Contact Me</h1>
            <div className="row d-flex justify-content-center contact">
                <div className="col-lg-3 col-md-12 d-flex flex-column justify-content-center align-items-center contactbox">
                    <i className="fas fa-5x fa-at" />
                    <h1 className="contacthead">Email</h1>
                    <p className="contactp">hemanthram53@gmail.com ee18b132@smail.iitm.ac.in</p>
                </div>
                <div className="col-lg-3 col-md-12 d-flex flex-column justify-content-center align-items-center contactbox">
                    <i className="fas fa-5x fa-phone" />
                    <h1 className="contacthead">Phone</h1>
                    <p className="contactp">+91 9498866441</p>
                </div>
                <div className="col-lg-3 col-md-12 d-flex flex-column justify-content-center align-items-center contactbox">
                    <i className="fas fa-5x fa-map-marker-alt" />
                    <h1 className="contacthead">Address</h1>
                    <p className="contactp">Room 112, Ganga Hostel, IIT Madras, Chennai-36.</p>
                </div>
            </div>
            <hr></hr>
        </div>
    )
}